import { makeAutoObservable } from 'mobx';
import { validateUnderlyingPriceExit } from './validateUnderlyingPriceExit';

export class UnderlyingPriceExitData {
  underlyingPricePairs = [];

  constructor(initialData) {
    makeAutoObservable(this);
    if (initialData) {
      Object.keys(initialData).forEach(
        (field) => (this[field] = initialData[field])
      );
    }
  }
  resetToDefaults = () => {
    this.underlyingPricePairs = [];
  };
  updateTactic = (dataObj) => {
    for (const key in dataObj) {
      this[key] = dataObj[key];
    }
  };
  validate = () => {
    const result = validateUnderlyingPriceExit(this.underlyingPricePairs);
    return result;
  };
  returnJson = () => {
    return {
      underlyingPricePairs: this.underlyingPricePairs,
    };
  };
  //specific methods
  addPair = (pairObject) => {
    this.underlyingPricePairs.push(pairObject);
  };
  removePair = (index) => {
    const newArr = this.underlyingPricePairs.filter((_, i) => i !== index);
    this.underlyingPricePairs = newArr;
  };
  clearPair = () => {
    this.underlyingPricePairs = [];
  };
}
